// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"4f06e172","759":"e4ead37c","935":"364c0cf1"}[chunkId] + ".chunk.css";
};